import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import RsvpSelect from '~/glm/components/shared/rsvp-dropdown-select';

const guestStatsStructure = [
  { color: '#9699A0', label: 'Not Invited', filterType: 'not invited' },
  { color: '#CACCD0', label: 'Invited', filterType: 'no response' },
  { color: '#58BF81', label: 'Attending', filterType: 'accepted' },
  { color: '#000000', label: 'Declined', filterType: 'declined' },
];

export default class RsvpFilterDropdown extends React.Component {
  static propTypes = {
    rsvpFilter: PropTypes.func,
    setMenuState: PropTypes.func,
    currentSelection: PropTypes.string,
    border: PropTypes.bool,
    event: PropTypes.instanceOf(GdsEventModel),
    showNotInvited: PropTypes.bool,
  };

  handleClick = selectionObj => {
    const { setMenuState, rsvpFilter, event } = this.props;
    const { label } = selectionObj;

    rsvpFilter(label, event);

    if (setMenuState) {
      setMenuState(false);
    }
  };

  render() {
    const { currentSelection, border = true, showNotInvited = false } = this.props;
    const notInvitedStruct = guestStatsStructure[0];
    return (
      <Fragment>
        {showNotInvited && (
          <RsvpSelect
            border={border}
            color={notInvitedStruct.color}
            key="notinvited-filter"
            label={notInvitedStruct.label}
            onClick={() => this.handleClick(notInvitedStruct)}
            selected={currentSelection === notInvitedStruct.label}
          />
        )}
        {guestStatsStructure.slice(1, 4).map((structure, idx) => {
          const { color, label } = structure;
          return (
            <RsvpSelect
              border={border}
              color={color}
              key={idx}
              label={label}
              onClick={() => this.handleClick(structure)}
              selected={currentSelection === label}
            />
          );
        })}
      </Fragment>
    );
  }
}
